import { render, staticRenderFns } from "./lawyerHome.vue?vue&type=template&id=0b9ae3f6&scoped=true"
import script from "./lawyerHome.vue?vue&type=script&lang=js"
export * from "./lawyerHome.vue?vue&type=script&lang=js"
import style0 from "./lawyerHome.vue?vue&type=style&index=0&id=0b9ae3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ae3f6",
  null
  
)

export default component.exports